// Text-story background presets (gold/silver/dark branded palette).
export const STORY_BGS = [
  { key: "gold", css: "linear-gradient(135deg,#F3D56D 0%,#D4AF37 55%,#8a6d1f 100%)", fg: "#1a1608" },
  { key: "silver", css: "linear-gradient(135deg,#e9edf2 0%,#b9c2cc 55%,#7c8794 100%)", fg: "#14181d" },
  { key: "midnight", css: "linear-gradient(135deg,#1b1c22 0%,#0c0d10 100%)", fg: "#F3D56D" },
  { key: "ember", css: "linear-gradient(135deg,#7a1f1f 0%,#2a0a0a 100%)", fg: "#f6d7c4" },
  { key: "ocean", css: "linear-gradient(135deg,#123a5c 0%,#05131f 100%)", fg: "#cfe6f5" },
  { key: "forest", css: "linear-gradient(135deg,#14432b 0%,#06170e 100%)", fg: "#d3f0d9" },
  { key: "violet", css: "linear-gradient(135deg,#3a1e63 0%,#140a24 100%)", fg: "#e6d7f5" },
  { key: "rose", css: "linear-gradient(135deg,#7a2a4d 0%,#2a0e1c 100%)", fg: "#f7d7e6" },
];

export function bgByKey(key) {
  return STORY_BGS.find((b) => b.key === key) || STORY_BGS[0];
}

export const STORY_FONTS = [
  { key: "heading", label: "Serif", css: "'Playfair Display', Georgia, serif" },
  { key: "clean", label: "Clean", css: "system-ui, -apple-system, sans-serif" },
  { key: "mono", label: "Mono", css: "'Courier New', monospace" },
];

export const STORY_EMOJIS = ["❤️", "😂", "😮", "😍", "🔥", "👏", "😢", "🎉", "💯", "👑", "⭐", "🙏"];
export const REACT_EMOJIS = ["❤️", "😂", "😮", "😍", "🔥", "😢"];
